import { shortenIdentifier } from "@pages/AdminDashboard/ui/DataTable/cells";
import { ShipCase } from "@types-runway/admin";

// How a title, step or banner names the Case: its Case ID by the first segment, or its number
// with a "#" when it has no Case ID (SHIPUI-R37).
export const nameCase = (shipCase: ShipCase): string =>
  shipCase.caseId ? `Case ${shortenIdentifier(shipCase.caseId)}` : `Case #${shipCase.id}`;
